<div class="migo-dialog">
    <mg-icons class="mx-auto h-12 w-12 block" *ngIf="type" [name]="type"></mg-icons>
    <h6 class="text-center title-6-bold">{{ title }}</h6>
    <p class="body text-center" #messageArea></p>
    <div class="w-full" mat-dialog-actions>
      <mg-button class="w-full" [mat-dialog-close]="true">
        {{ buttonText }}
      </mg-button>
    </div>
</div>
